
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import React, { useState, useEffect, useRef } from 'react';
import {simpleReq} from "../../utils/globalutils.js"
import imageBtnIcone from "../../assets/image/imageicone.png";
function InputFile({onFileIsUploaded,resetFileUpload}){

    const fileInput = useRef(null);
    const onClickFileBtn = (evt) => {
        fileInput.current.click();
    }

    var onFileRequestUpload = async () => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(fileInput.current.files[0]);
        fileReader.onload = async (event) => {
            var isHttps = window.location.protocol == "https:" ? true : false
            var baseUrl = isHttps == true ? "https://files.kojyto.fr" : "https://files.kojyto.fr";
            var d = await simpleReq(baseUrl +"/upload?permanent=false&filename=" + encodeURIComponent(fileInput.current.files[0].name), fileInput.current.files[0]);
            baseUrl += "/" + d.path;
            onFileIsUploaded(baseUrl);
            fileInput.current.value = '';
        }
    }
    return (
        <>
            <input
            ref={fileInput}
            onChange={onFileRequestUpload}
            type="file"
            id="fileElem"
            accept={"image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/plain,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/rtf,.doc,.docx,.xls,.xlsx,.csv,.txt,.ppt,.pptx,.md"}
            style={{display:"none"}} />
            <button id="fileSelect" onClick={onClickFileBtn} onMouseDown={(e) => {e.preventDefault()}} type="button" className="size-8"><img width={"32px"} src={imageBtnIcone} /></button>
            
        </>
    )
}

export default InputFile;